/* SARATTI — Begin with Colour · behaviour
   Idempotent: safe to run repeatedly (theme editor re-renders sections). */
(function () {
  'use strict';

  function initHero(root) {
    if (!root || root.dataset.bwcInit === '1') return;
    root.dataset.bwcInit = '1';

    /* --- rotating hero backgrounds --- */
    var bg = root.querySelector('[data-bwc-bg]');
    if (bg) {
      var imgs = Array.prototype.slice.call(bg.querySelectorAll('img'));
      if (imgs.length) {
        var i = 0;
        imgs[0].classList.add('on');
        if (imgs.length > 1) {
          var delay = parseInt(bg.dataset.bwcInterval, 10) || 6500;
          var timer = setInterval(function () {
            if (!document.body.contains(bg)) { clearInterval(timer); return; }
            imgs[i].classList.remove('on');
            i = (i + 1) % imgs.length;
            imgs[i].classList.add('on');
          }, delay);
        }
      }
    }

    /* --- "where would you like to begin" selector --- */
    var sel = root.querySelector('[data-bwc-sel]');
    if (!sel) return;
    var btn = sel.querySelector('[data-bwc-selbtn]');
    var val = sel.querySelector('[data-bwc-selval]');

    function close() { sel.classList.remove('open'); if (btn) btn.setAttribute('aria-expanded', 'false'); }
    function toggle(e) {
      e.stopPropagation();
      var open = sel.classList.toggle('open');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (btn) btn.addEventListener('click', toggle);
    document.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    sel.querySelectorAll('[data-bwc-opt]').forEach(function (o) {
      o.addEventListener('click', function (e) {
        e.stopPropagation();
        var label = o.querySelector('[data-bwc-optlabel]');
        if (val && label) val.textContent = label.textContent.trim();
        close();
        var target = o.getAttribute('data-bwc-opt');
        var dest = target ? document.getElementById(target) : null;
        if (dest) dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* --- scroll reveal --- */
  var io = null;
  function initReveal(scope) {
    var nodes = (scope || document).querySelectorAll('.bwc .rv:not([data-bwc-rv])');
    if (!nodes.length) return;
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-bwc-rv', '1'); n.classList.add('in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (x) {
          if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); }
        });
      }, { threshold: 0.08 });
    }
    nodes.forEach(function (n) { n.setAttribute('data-bwc-rv', '1'); io.observe(n); });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-bwc-hero]').forEach(initHero);
    initReveal(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  /* theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.dataset) delete e.target.dataset.bwcInit;
    boot(e.target);
  });
})();
